<template functional>
  <!-- eslint-disable -->
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.686,13.081A9.743,9.743,0,0,1,3.75,17.186V20a.75.75,0,0,1-1.5,0V15A.75.75,0,0,1,3,14.25H8a.75.75,0,0,1,0,1.5H4.67A8.235,8.235,0,0,0,20.2,12.919a.75.75,0,1,1,1.491.162ZM21,3.25a.75.75,0,0,0-.75.75V6.814A9.743,9.743,0,0,0,2.314,10.919a.75.75,0,0,0,.665.827.738.738,0,0,0,.082,0,.75.75,0,0,0,.744-.669A8.235,8.235,0,0,1,19.33,8.25H16a.75.75,0,0,0,0,1.5h5A.75.75,0,0,0,21.75,9V4A.75.75,0,0,0,21,3.25Z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconRotate',
};
</script>